import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      monthlySales: false,
      ytdBuyTypes: false,
      monthlyStockTurnoverRate: false,
      stocks: false,
      salesBrands: false,
      salePerformance: false,
    },
    dashboardData: {
      counters: {
        ytdSales: 0,
        mtdSales: 0,
        totalProfitRate: 0,
        swapsRate: 0,
      },
      monthlySales: {
        series: [],
        categories: [],
      },
      ytdBuyTypes: {
        series: [],
        labels: [],
        colors: [],
      },
      monthlyStockTurnoverRate: {
        series: [],
        categories: [],
        colors: [],
      },
      stocks: {
        series: [],
        categories: [],
        colors: [],
      },
      salesBrands: {
        series: [],
        categories: [],
        colors: [],
      },
      salePerformance: {
        buyTypes: [],
        grandTotals: {
          ytdSales: 0,
          ytdBuys: 0,
          ytdStockTurnoverRate: 0,
          connections: 0,
          stocks: 0,
          totalProfitRate: 0,
        },
      },
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'monthlySales') {
        state.loadings.monthlySales = data.status
      }
      if (data.type === 'ytdBuyTypes') {
        state.loadings.ytdBuyTypes = data.status
      }
      if (data.type === 'monthlyStockTurnoverRate') {
        state.loadings.monthlyStockTurnoverRate = data.status
      }
      if (data.type === 'stocks') {
        state.loadings.stocks = data.status
      }
      if (data.type === 'salesBrands') {
        state.loadings.salesBrands = data.status
      }
      if (data.type === 'salePerformance') {
        state.loadings.salePerformance = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'monthlySales') {
        state.dashboardData.monthlySales = data.data
      }
      if (data.type === 'ytdBuyTypes') {
        state.dashboardData.ytdBuyTypes = data.data
      }
      if (data.type === 'monthlyStockTurnoverRate') {
        state.dashboardData.monthlyStockTurnoverRate = data.data
      }
      if (data.type === 'stocks') {
        state.dashboardData.stocks = data.data
      }
      if (data.type === 'salesBrands') {
        state.dashboardData.salesBrands = data.data
      }
      if (data.type === 'salePerformance') {
        state.dashboardData.salePerformance = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          ytdSales: 0,
          mtdSales: 0,
          totalProfitRate: 0,
          swapsRate: 0,
        },
        monthlySales: {
          series: [],
          categories: [],
        },
        ytdBuyTypes: {
          series: [],
          labels: [],
          colors: [],
        },
        monthlyStockTurnoverRate: {
          series: [],
          categories: [],
          colors: [],
        },
        stocks: {
          series: [],
          categories: [],
          colors: [],
        },
        salesBrands: {
          series: [],
          categories: [],
          colors: [],
        },
        salePerformance: {
          buyTypes: [],
          grandTotals: {
            ytdSales: 0,
            ytdBuys: 0,
            ytdStockTurnoverRate: 0,
            connections: 0,
            stocks: 0,
            totalProfitRate: 0,
          },
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/i2SalesLive?type=${params.type}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/i2SalesLive?type=${params.type}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
